var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-stage',{ref:"mapStage",attrs:{"config":_vm.configKonva}},[_c('v-layer',{ref:"mainLayer",attrs:{"config":_vm.configLayer}},[_c('MapWrapper')],1),_c('CurrentEventPanel'),_c('TimelinePanel')],1)}
var staticRenderFns = []

export { render, staticRenderFns }